<ng-container *ngIf="isShowingResults === false">
  <div class="comment" *ngIf="comment" [ngStyle]="{'color': color}">
    <div class="title">{{ "__CONFERENCE_COMMENT__" | translate }}:</div>
    <div>{{ comment }}</div>
  </div>

  <div class="item" *ngFor="let option of options; let i = index">
    <div class="question">{{ option.item.text }}</div>
    <div class="options options-{{ratingType}}"  [ngStyle]="optionsStyles">
      <div class="option"
           [ngClass]="{'selected': option.value == value || ratingType == 'stars' && option.value > 0 && value < option.value, 'stars': ratingType == 'stars', 'buttons': ratingType == 'buttons'}"
           *ngFor="let value of this.range let j = index" (click)="choose(option, value)">
        {{ ratingType == 'buttons' ? value : '' }}
      </div>
    </div>
  </div>

  <div class="legend" *ngIf="range.length > 0">
    <div class="less">{{ _card.legend1 ? _card.legend1 : rangeMin + ' - ' + '__INTERACTION_NOT_LIKELY__' | translate}}</div>
    <div class="most">{{ _card.legend2 ? _card.legend2 : rangeMax + ' - ' + '__INTERACTION_VERY_LIKELY__' | translate}}</div>
  </div>

  <app-card-button *ngIf="!isSubmitted"  [text]="'__INTERACTION_SUBMIT_RESPONSE__' | translate"  (onSubmit)="submit()" [ngClass]="{disabled: !isValid()}"></app-card-button>
  <app-card-button *ngIf="isEnableSwitchViews && isSubmitted" (click)="showResults()"
                   [tightLayout]="true" [text]="'__INTERACTION_DISPLAY_STATISTICS__' | translate"
                   [color]="'rgba(168, 150, 246, 0.5)'" [colorInverse]="'white'"></app-card-button>
</ng-container>
<ng-container *ngIf="isShowingResults === true && results">
  <app-card-results
    [results]="results"
  ></app-card-results>

  <app-card-button *ngIf="isEnableSwitchViews"
                   (click)="hideResults()"
                   [tightLayout]="true" [text]="'__INTERACTION_DISPLAY_MY_ANSWERS__' | translate"
                   [color]="'rgba(168, 150, 246, 0.5)'" [colorInverse]="'white'"></app-card-button>
</ng-container>
